import { Component, EventEmitter, Input, OnInit, Output,OnChanges } from '@angular/core';
import { ExcelService } from "../../../../services/ExcelService";

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css'],
    standalone: false
})
export class PaginationComponent implements OnChanges, OnInit {
  @Input() viewmode: string = "";
  @Input() printElementID: string = null;
  @Input() items: any[] = [];
  @Input() initialItemsPerPage: number = 25;

  @Output() onExport: EventEmitter<string> = new EventEmitter();
  @Output() onPageChange: EventEmitter<PageInfo> = new EventEmitter();

  public pagesCount = 1;
  public pageInfo = new PageInfo();

  constructor(private exportService: ExcelService) {
  }

  ngOnInit() {
    this.pageInfo.itemsPerPage = this.initialItemsPerPage;
  }

  public showPages() {
    return this.viewmode.indexOf("pages") >= 0;
  }
  public showHideEmpty() {
    return this.viewmode.indexOf("reports") >= 0;
  }
  public showExcel() {
    return this.viewmode.indexOf("excel") >= 0;
  }
  public showPrint() {
    return this.viewmode.indexOf("print") >= 0;
  }

  public excelExport() {
    if (this.printElementID != null) {
      const tbl = document.getElementById(this.printElementID);
      if (tbl)
        this.exportService.exportAsExcelFile(tbl);
    }
    else
      this.onExport.emit("excel");

  }
  public pdfExport() {
    (window as any).print();
  }

  ngOnChanges() {
    var me = this;
    var pagesCount = this.pagesCount;

    if (this.items) {
      setTimeout(function () {
        me.pagesCount = Math.max(1, Math.ceil(me.items.length / me.pageInfo.itemsPerPage));
        if (me.pagesCount != pagesCount)
          me.setPage(1);
      }, 100);
    }
  }
  public setItemsPerPage(itempPerPage) {
    this.pageInfo.itemsPerPage = itempPerPage;
    this.ngOnChanges();
  }
  public firstPage() {
    this.setPage(1);
  }
  public lastPage() {
    this.setPage(this.pagesCount);
  }
  public nextPage() {
    this.setPage(this.pageInfo.pageNumber + 1);
  }
  public prevPage() {
    this.setPage(this.pageInfo.pageNumber - 1);
  }
  private setPage(page: number) {
    this.pageInfo.pageNumber = Math.min(Math.max(page, 1), this.pagesCount);
    this.onPageChange.emit(this.pageInfo);
  }
}


export class PageInfo {
  public itemsPerPage: number = 25;
  public pageNumber: number = 1;
}
